import React, { useEffect, useState } from "react";
import { HiOutlineTicket } from "react-icons/hi";
import useMethodAccount from "./hooks/useMethodAccount";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import SelectPassMobile from "./selectPass/SelectPassMobile";
import SelectPassDesktop from "./selectPass/SelectPassDesktop";
import LimitedOpenPassDesktop from "./limitedOpenPass/LimitedOpenPassesDesktop";
import LimitedOpenPassMobile from "./limitedOpenPass/LimitedOpenPassesMobile";
import { BiCommentError } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { State } from "../../store";
import MobileComponentToShowExercises from "./selectPass/MobileComponentToShowExercises";

const AccountPasses: React.FC = () => {
  const { t } = useTranslation();
  const { tickets, passes, getLimited, getSelect } = useMethodAccount();
  const isDesktop = useDesktopSize();
  const [deafult, setDeafult] = useState<boolean>(true);
  const [indexOfTickets, setIndexOfTickets] = useState<number>(999);
  const allowReservationByPassOnFitnessPlan = useSelector(
    (state: State) => state.config.configuration.allowReservationByPassOnFitnessPlan
  );

  useEffect(() => {
    getLimited();
    getSelect();
  }, []);

  const changeDeafultView = (i: number) => {
    setDeafult(false);
    setIndexOfTickets(i);
  };
const backToDeafultView = () => {
  setDeafult(true)
}

  const updateExercises = () => {
    getSelect();
  };

  return (
    <React.Fragment>
      {deafult ? (
        <div className="account-tickets">
          <h3 className="ticket-title flex-start-center">
            <HiOutlineTicket className="icon" />
            {t("karnety_zajeciowe")}
          </h3>

          <div className="flex-start flex-wrap">
            {tickets.length > 0 ? (
              <React.Fragment>
                {tickets.map((ticket, index) => (
                  <React.Fragment>
                    {isDesktop ? (
                      <div key={index} className="select-pass-container">
                        <SelectPassDesktop ticket={ticket} getSelect={getSelect} />
                      </div>
                    ) : (
                      <div key={index} className="select-pass-container">
                        <SelectPassMobile
                          ticket={ticket}
                          getSelect={getSelect}
                          changeDeafultView={changeDeafultView}
                          index={index}
                        />
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="alert alert-yellow">
                  <BiCommentError className="alert-icon" />
                  <b>{t("brak_karnetow")}</b>
                </div>
              </React.Fragment>
            )}
          </div>

          <h3 className="ticket-title flex-start-center">
            <HiOutlineTicket className="icon" />
            {t("karnety_open_i_ilosciowe")}
          </h3>

          <div className="flex-start flex-wrap">
            {passes.length > 0 ? (
              <React.Fragment>
                {passes.map((ticket, index) => (
                  <div key={index} className="select-pass-container">
                    {isDesktop ? <LimitedOpenPassDesktop ticket={ticket} getSelect={getLimited} /> : <LimitedOpenPassMobile ticket={ticket}  getSelect={getLimited} />}
                  </div>
                ))}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="alert alert-yellow">
                  <BiCommentError className="alert-icon" />
                  <b>{t("brak_karnetow")}</b>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      ) : (
        <MobileComponentToShowExercises ticket={tickets[indexOfTickets]} getSelect={getSelect} backToDeafultView={backToDeafultView} />
      )}
    </React.Fragment>
  );
};

export default AccountPasses;
